















import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import PolygonViewer from "@/components/wrappedGoogleMaps/PolygonViewer.vue";
import geojson from '@/components/wrappedGoogleMaps/geo.json';
import * as resultsService from "@/services/results/index";

@Component({
  name: 'AgroInteractiveMapController',
  components: {
    PolygonViewer,
  },
})
export default class AgroInteractiveMapController extends Vue {

  @Prop(String) private url?: string;

  @Prop(String) private downloadFileName?: string;
  
  @Prop(String) private farmAnalysisUuid?: string; 

  @PropSync('selected', { type: Array, default: () => [] }) private selectedCrops!: string[];

  @Prop({type: Object, default: () => null }) private fallback!: GeoJSON.GeoJSON | null;

  @Prop({ type: String, default: "base-style" })
  private mapClass!: string;

  private polygon?: GeoJSON.GeoJSON | null = null;

  @Prop(Array)
  private extraPolygons?: GeoJSON.GeoJSON[];

  @Watch('url')
  private async updateGeojson() {
    await this.updatePolygon();
  }

  @Watch('fallback')
  private async updateFallback() {
    await this.updatePolygon();
  }

  private downloadAsGeoJson(polygon: GeoJSON.GeoJSON | null) {
    if (!!polygon) {
      const blob = new Blob([JSON.stringify(polygon)], { type: 'application/geo+json; encoding=utf8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = this.downloadFileName!;
      link.href = url;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  }

  private async updatePolygon() {
    if (!!this.url) {
      try {
        this.polygon = (await resultsService.downloadGeoJson(this.url));
      } catch {}
    } else {
      this.polygon = this.fallback;
    }
  }

  private async mounted() {
    await this.updatePolygon();
  }
}
